// extracted by mini-css-extract-plugin
export const authorList = "missioncard-module--authorList--oBbH5";
export const ecClass = "missioncard-module--ecClass--2hmrQ";